import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import isMobile from 'is-mobile';
import accounting from 'accounting';
import { NotificationManager } from 'react-notifications';
import { Redirect } from 'react-router-dom';

import { getCurso, agregarCarrito, quitarCarrito, adquirirCurso } from '../actions';
import { formatHTML } from '../utils';
import CursoModuloCellphone from '../components/curso-modulo-cellphone';

class DetalleCurso extends Component {
  constructor(props){
    super(props);

    this.state = {
      redirect: null
    };

    this.adquirir = this.adquirir.bind(this);
  }

  componentDidMount(){
    this.props.getCurso(this.props.match.params.idcurso);
  }

  noAdquirido(){
    if (this.props.curso !== undefined && this.props.curso.costo === "0") {
      return false;
    }
    return this.props.usuario===undefined || this.props.usuario===null ||
      this.props.usuario.cursosDisponibles===undefined || this.props.usuario.cursosDisponibles.indexOf(this.props.curso.id) < 0;
  }

  renderModulos(){
    let noadquirido = this.noAdquirido();
    //SI NO ES UN CELULAR
    if (!isMobile()) return this.props.curso.modulos.map((modulo)=>{
      if (modulo.completado!==undefined) {
        return (
          <tr key={modulo.id}>
            <th>{modulo.nombre}</th>
            <td>{formatHTML(modulo.descripcion)}</td>
            <td> <span className="badge badge-info">{modulo.completado}%</span></td>
            <td>{noadquirido? "": <Link to={`/classroom/${modulo.id}`} className="btn btn-light">Entrar</Link>}</td>
          </tr>
        );
      }
      return (
        <tr key={modulo.id}>
          <th>{modulo.nombre}</th>
          <td>{modulo.descripcion}</td>
          <td>{noadquirido? "": <Link to={`/classroom/${modulo.id}`} className="btn btn-light">Entrar</Link>}</td>
        </tr>
      );
    });
    //SI ES UN CELULAR
    return this.props.curso.modulos.map((modulo)=>{
      return (<CursoModuloCellphone key={modulo.id} modulo={modulo} adquirido={!noadquirido} />);
    });
  }

  adquirir(curso, usuario){
    if(usuario!==null && usuario.id!==undefined){
      this.props.adquirirCurso(curso, this.props.usuario);
    } else {
      NotificationManager.info(
        "Por favor inicie sesión para continuar",
        "Atención",
        5000
      );
      this.setState({ redirect: "/login" });
    }
  }

  mensajeCurso(curso){
    let message = `Quiero adquirir el curso '${curso.titulo}'`
    return encodeURIComponent(message)
  }

  renderBotonCompra(curso){
    let left_item, right_item
    console.log("props", this.props);
    if(!this.noAdquirido()){
      left_item = <h3><span className="badge badge-success float-left">Curso Adquirido</span></h3>;
    }else{
      left_item = <h3><span className="badge badge-success float-left">{curso.costo!=="0" ? accounting.formatMoney(curso.costo, "Gs", 0, ".") : "Gratis!!"}</span></h3>;
    }

    if (!this.noAdquirido(curso) || this.props.curso.costo === "0"){
      right_item = "";

    // } else if (this.props.carrito!=null && this.props.carrito[curso.id]!==undefined) {
    //   right_item = (
    //     <Link to="/carrito" className="btn btn-primary" >
    //       Ver en el carrito
    //     </Link>
    //   );
    } else if(curso.costo+""==="0") {
      right_item = (
        <a className="btn btn-primary"
          onClick={() => this.adquirir(curso, this.props.usuario)} >
          Comenzar el curso
        </a>
      );
    } else {

        // <a className="btn btn-primary"
        //  onClick={()=>this.props.agregarCarrito(curso)} >
        //  Agregar al Carrito
        // </a>
      right_item = (
        <a href={`https://wa.me/5950985837488?text=${this.mensajeCurso(curso)}`} className="badge badge-success float-right mr-3">
          Contactar para Adquirir <br/>
          Mauricio Medina: 0985 837 488 <i className="fab fa-whatsapp"></i>
        </a>
      );
    }

    return (
      <div>
        {left_item}{right_item}
      </div>
    );
  }

  renderTitle(curso){
    if(isMobile()===true){
      return (
        <div>
          <img className="card-img-top img-rounded" src={window.location.hostname==="localhost" ? "https://aulas.ceis.com.py"+curso.img : curso.img} alt={`Imagen del curso ${curso.titulo}`} />
          <div className="card-body">
            <h5 className="card-title">{curso.titulo}</h5>
            <p className="card-text">{formatHTML(curso.descripcion)}</p>
            <span className="control-section">
              <a className="btn btn-light" onClick={this.props.history.goBack}>Volver</a>
              {this.renderBotonCompra(curso)}
            </span>
          </div>

        </div>
      );
    }
    return (
      <div className="card-body">
        <img className="card-img-top img-rounded" src={window.location.hostname==="localhost" ? "https://aulas.ceis.com.py"+curso.img : curso.img} alt={`Imagen del curso ${curso.titulo}`} />
        <div className="container">
          <h5 className="card-title">{curso.titulo}</h5>
          <p className="card-text">{formatHTML(curso.descripcion)}</p>
          <span className="control-section">
            <a className="btn btn-light" onClick={this.props.history.goBack}>Volver</a>
            {this.renderBotonCompra(curso)}
          </span>
        </div>
      </div>
    );
  }

  renderEncabezados(){
    if(!isMobile()){
      if(this.props.curso.modulos.length>0 && this.props.curso.modulos[0].completado!==undefined){
        return (
            <tr>
              <th>Nombre</th>
              <th style={{minWidth: "300px"}} >Descripción</th>
              <th>Completo</th>
              <th></th>
            </tr>
          );
      } else {
        return (
          <tr>
            <th>Nombre</th>
            <th style={{minWidth: "300px"}} >Descripción</th>
            <th></th>
          </tr>
        );
      }
    } else {
      return (
        <tr>
          <th>Módulos</th>
        </tr>
      );
    }
  }

  render(){
    if (this.state.redirect!==null) {
      return <Redirect to={this.state.redirect} />;
    }
    let curso = this.props.curso;
    if(this.props.usuario!==null && this.props.usuario.id!==undefined
      && this.props.curso!==null && this.props.curso.modulos.length>0 &&
      this.props.curso.modulos[0].completado===undefined && !this.noAdquirido()) {
      this.props.getCurso(this.props.match.params.idcurso, this.props.usuario.id);
    }
    if (curso===null) {
      return (
        <section id="course-detail">
          <div className="container">

            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Cargando...</h5>
              </div>
            </div>
          </div>

        </section>
      );
    }
    if (curso.error!==undefined && curso.error!==null) {
      return (
        <section id="course-detail">
          <div className="container">

            <div className="card">
              <div className="card-body">
                <h5 className="card-title">{curso.error}</h5>
              </div>
            </div>
          </div>

        </section>
      );
    }
    return (
      <section id="course-detail">
        <div className={ isMobile() ? "" : "container" }>

          <div className="card">
            {this.renderTitle(curso)}
            <hr />
            <div id="content-course">
              <h3 className="card-title">Contenido del Curso</h3>
              <div className="table-responsive">
                <table className="table">
                  <thead className="thead-light">
                    {this.renderEncabezados()}
                  </thead>
                  <tbody>
                    {this.renderModulos()}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </div>
      </section>
    );
  }
}

function mapStateToProps({ curso, carrito, usuario }) {
  return { curso, carrito, usuario };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getCurso, agregarCarrito, quitarCarrito, adquirirCurso
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(DetalleCurso);



// WEBPACK FOOTER //
// ./src/containers/detalle_curso.js